export { default } from './ProductCategories'
